import Icon from '../components/Icon.vue'

Icon.register({
  'envelope-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352zM178.1 262.1c10.5 7.7 31.4 26.1 45.9 25.9 14.5 0.2 35.4-18.2 45.9-25.9 90.7-65.8 89.7-66 114.1-84.9v-25.2c0-13.3-10.7-24-24-24h-272c-13.3 0-24 10.7-24 24v25.2c24.4 19 23.4 19.1 114.1 84.9zM384 217.8c-14 10.8-33.3 25.2-95.3 70.2-13.7 10-37.8 32.2-64.7 32-26.7 0.1-50.5-21.7-64.7-32-62-45-81.3-59.4-95.3-70.2v142.2c0 13.3 10.7 24 24 24h272c13.3 0 24-10.7 24-24v-142.2z'
      }
    ]
  }
})
